module.exports = __webpack_public_path__ + "img/expodecor_mosaic1020_blackandwhite_cement_tiles.f3e7af53.jpg";